<template>
    <div class="container-fluid">
        <b-card no-body class="my-2">
            <b-card-header class="">
                <b-row>
                    <b-col md="6">
                        <b-card-title class="card-title-page-garden-help-default my-1">
                            Staff Profile
                        </b-card-title>
                    </b-col>
                    <!-- <b-col md="6">
                        <b-button variant="garden-help-info-light" class="btn-bumblebee btn-garden-help float-end">
                            <font-awesome-icon icon="fa-solid fa-pen" /> Edit</b-button>
                    </b-col> -->
                </b-row>

            </b-card-header>
        </b-card>


        <b-overlay :show="show_overlay" variant="success" :opacity=".5" rounded="sm">

            <b-card class="profile-details-card-garden-help" no-body>
                <b-card-header class="">
                    <b-row>
                        <b-col lg="9" md="9">
                            <b-card-title class="card-title-garden-help">
                                Contractor Details
                            </b-card-title>
                        </b-col>
                        <!-- <b-col lg="3" md="3" class="d-flex justify-content-end align-items-center"
                        v-if="contractor_details_action_type == 'view'">
                            <b-button variant="garden-help-info-light" class="btn-bumblebee btn-garden-help float-end"
                                @click="contractor_details_action_type = 'edit'">
                                <font-awesome-icon icon="fa-solid fa-pen" /> Edit</b-button>
                        </b-col> -->
                    </b-row>

                </b-card-header>
                <b-card-body class="p-0">
                    <PersonalInfo :type="contractor_details_action_type" :name="contractor.name"
                        :first_name="contractor.first_name" :last_name="contractor.last_name" :email="contractor.email"
                        :phone_number="contractor.phone" :address="contractor.address" />
                        
                        <b-row class="justify-content-end mx-0 mb-3" v-if="contractor_details_action_type == 'edit'">
                            <b-col xl="2" lg="3" md="6">
                                <b-button variant="garden-help-danger-light" class="btn-bumblebee btn-garden-help w-100"
                                    @click="contractor_details_action_type='view'">Cancel</b-button>
                            </b-col>
                            <b-col xl="2" lg="3" md="6">
                                <b-button variant="garden-help-primary" class="btn-bumblebee btn-garden-help w-100"
                                    @click="contractor_details_action_type='view'">Save</b-button>
                            </b-col>
                        </b-row>


                </b-card-body>
            </b-card>
            <b-card class="profile-details-card-garden-help" no-body>
                <b-card-header class="">
                    <b-row>
                        <b-col lg="9" md="9">
                            <b-card-title class="card-title-garden-help">
                                Work details
                            </b-card-title>
                        </b-col>
                        <!-- <b-col lg="3" md="3" class="d-flex justify-content-end align-items-center"
                        v-if="work_details_action_type == 'view'">
                            <b-button variant="garden-help-info-light" class="btn-bumblebee btn-garden-help float-end"
                                @click="work_details_action_type = 'edit' ">
                                <font-awesome-icon icon="fa-solid fa-pen" /> Edit</b-button>
                        </b-col> -->
                    </b-row>
                </b-card-header>
                <b-card-body class="p-0">
                    <WorkInfo :type="work_details_action_type" :experience_level.sync="contractor.experience_level"
                        :service.sync="contractor.services" :services_str="contractor.services_str"
                        :services_id="contractor.services_id" :is_sub_contractor="true" />
                    
                        <b-row class="justify-content-end mx-0 mb-3" v-if="work_details_action_type == 'edit'">
                            <b-col xl="2" lg="3" md="6">
                                <b-button variant="garden-help-danger-light" class="btn-bumblebee btn-garden-help w-100"
                                    @click="work_details_action_type='view'">Cancel</b-button>
                            </b-col>
                            <b-col xl="2" lg="3" md="6">
                                <b-button variant="garden-help-primary" class="btn-bumblebee btn-garden-help w-100"
                                    @click="work_details_action_type='view'">Save</b-button>
                            </b-col>
                        </b-row>
                </b-card-body>
            </b-card>

            <b-card class="profile-details-card-garden-help" no-body>
                <b-card-header class="">
                    <b-row>
                        <b-col lg="9" md="9">
                            <b-card-title class="card-title-garden-help">
                                Images/Previous works </b-card-title>
                        </b-col>
                        <!-- <b-col lg="3" md="3" class="d-flex justify-content-end align-items-center">
                            <b-button variant="garden-help-info-light" class="btn-bumblebee btn-garden-help float-end"
                                disabled>
                                <font-awesome-icon icon="fa-solid fa-pen" /> Edit</b-button>
                        </b-col> -->
                    </b-row></b-card-header>
                <b-card-body class="">
                    <VueSlickCarousel v-bind="settings" class="slick-slider-garden-help" v-if="contractor.media.length>0">
                        <div v-for="item in contractor.media.filter(
                                (v) => v.media_type == 'company_image'
                            )" :key="item.id" class="">
                            <div> <img :src="item.path" class="m-auto" />
                            </div>
                        </div>
                    </VueSlickCarousel>
                    <p v-else class="text-center form-label-garden-help">No media found</p>

                </b-card-body>
            </b-card>

            <StaffJobsTable :staff_id="staff_id"/>
        </b-overlay>

    </div>
</template>


<script>
import axios from "axios";
import $ from "jquery";
import PersonalInfo from "../profile_details_components/PersonalInfo.vue";
import CompanyDetails from "../profile_details_components/CompanyDetails.vue";
import WorkInfo from "../profile_details_components/WorkInfo.vue";
import SocialMediaInfo from "../profile_details_components/SocialMediaInfo.vue";
import StaffJobsTable from '../../jobs/staff/JobsTable.vue'

export default {
    name: "GardenHelpContractorProfile",
    components: { PersonalInfo, CompanyDetails, WorkInfo, SocialMediaInfo,StaffJobsTable },
    data() {
        return {
            show_overlay: false,
            client_name: "GARDENHELP",
            user_type: localStorage.getItem('user_type'),
            staff_id: null, // logined user


            settings: {
                dots: false,
                infinite: false,
                speed: 500,
                slidesToShow: 4,
                slidesToScroll: 4,
                swipeToSlide: true,
                responsive: [
                    //col-xl-2 col-lg-3 col-md-3 col-6
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
            },

            contractor: null,

            contractor_details_action_type: 'view',
            work_details_action_type: 'view',
            images_details_action_type: 'view',
        }
    },
    mounted() {
        this.staff_id = Number(this.$route.params.id)

        // this.getFilterData()

        this.getContractorData()
    },
    methods: {
        getContractorData() {
            console.log("in get staff data", this.user_type, this.staff_id)
            this.show_overlay = true

            axios
                .get("/operator/contractor/profile/"+this.staff_id, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        Authorization:
                            "Bearer " +
                            JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    console.log(response)
                    console.log(response.data)
                    console.log(response)
                    this.contractor = response.data;

                    let services_str = [], services_id = []

                    for (let i = 0; i < response.data.services.length; i++) {
                        let service = response.data.services[i]
                        services_str.push(service.name)
                        services_id.push(service.id)
                    }

                    this.contractor.services_str = services_str
                    this.contractor.services_id = services_id

                    this.show_overlay = false

                });
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/projects/garden_help/contractor/staff/ViewProfile.vue